//记得在 src\components\lang\zhLoad.js 里面添加对象
const role= {
    roleCode: '角色编码',
    roleName: '角色名称',
    remark:'备注',
    menuList:"菜单列表",
    permission:"功能权限",
    addRole:'角色新增',
    editRole:'角色修改',
    activeOff:'是否可用',
    exportData:'导出权限',
    assignPermission:'权限分配',
    msg:{
        roleName:'请输入角色名称',
        roleCode:'请输入角色编码',
        clientId:"请选择应用编码"
    }
};
export default role



// WEBPACK FOOTER //
// ./src/page/auth/role/lang/role.zh.js